import { createUseStyles } from "react-jss";

interface Props {
  backgroundColor?: any;
  isEmbed?: any;
};

const useStyles = createUseStyles((theme: any) => ({
  loadingScreen: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    bottom: '0px',
    right: '0px',
    zIndex: theme.zIndex.screen,
    backgroundColor: (props: Props) => props.backgroundColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > svg': {
      maxWidth: '60%',
    }, 
  },
  loadingWrapper: {
    position: 'absolute',
    top: (props: Props) => {
      if(!props.isEmbed) return '75%';
      else return '';
    },
    transform: (props: Props) => {
      if(!props.isEmbed) return 'translateY(-75%)';
      else return '';
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    '& > span': {
      color: theme.colors.primaryBlue[500],
      fontWeight: 'bold',
      marginTop: '8px',
      '&.loading': {
        color: theme.colors.primaryBlue[500],
      },
      '&.failed': {
        color: theme.colors.systemRed[500],
      },
    },
  },
  loading: {
    position: 'relative',
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.5rem',
    width: '100%',
    maxWidth: '100%',
    position: 'absolute',
    bottom: '43px',
    left: '50%',
    transform: 'translateX(-50%)',
    '& > span': {
      color: theme.colors.primaryBlue[500],
      whiteSpace: 'nowrap',
      '& > span': {
        fontWeight: 'bold',
      },
    },
  },
  buttons: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
  },
  failed: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    bottom: '103px',
    left: '50%',
    transform: 'translateX(-50%)',
    '& > span': {
      textAlign: 'center',
      color: '#EE576C',
      fontWeight: 'bold',
    },
  },
  spinner: {
    '& svg': {
      color: theme.colors.primaryBlue[500],
    },
  },
}));

export default useStyles;